export const myProfileTranslations = {
  lv: {
    title: 'Mans profils',
    personal: 'Mani dati',
    subtitle: 'Katrs lauks tiek saglabāts atsevišķi.',
    information: 'Informācija',
    account: 'Konts',
    edit: 'Rediģēt',
    save: 'Saglabāt',
    saved: 'Izmaiņas saglabātas',
    upload: 'Augšupielādēt',
    portrait: 'Attēls',
    portraitHint: 'PNG vai JPEG līdz 3,5 MB',
    portraitError: 'Izvēlieties PNG vai JPEG attēlu līdz 3,5 MB.',
    language: 'Saziņas valoda',
    required: 'Lauks ir obligāts',
    invalidEmail: 'Ievadiet derīgu e-pasta adresi',
    password: 'Parole',
    passwordHint: 'Nomainiet paroli, ar kuru piesakāties edy365.',
    changePassword: 'Mainīt paroli',
    currentPassword: 'Pašreizējā parole',
    currentPasswordRequired: 'Ievadiet pašreizējo paroli',
    passwordChanged: 'Parole nomainīta',
    changePasswordError: 'Neizdevās nomainīt paroli. Mēģiniet vēlreiz.',
    fields: {
      firstName: 'Vārds',
      lastName: 'Uzvārds',
      email: 'E-pasts',
      phone: 'Tālrunis',
      pk: 'Personas kods',
      address: 'Adrese',
      bankAccount: 'Bankas konts',
      description: 'Par mani',
    },
  },
  en: {
    title: 'My profile',
    personal: 'My data',
    subtitle: 'Each field is saved separately.',
    information: 'Information',
    account: 'Account',
    edit: 'Edit',
    save: 'Save',
    saved: 'Changes saved',
    upload: 'Upload',
    portrait: 'Photo',
    portraitHint: 'PNG or JPEG up to 3.5 MB',
    portraitError: 'Choose a PNG or JPEG image up to 3.5 MB.',
    language: 'Communication language',
    required: 'This field is required',
    invalidEmail: 'Enter a valid email address',
    password: 'Password',
    passwordHint: 'Change the password you use to sign in to edy365.',
    changePassword: 'Change password',
    currentPassword: 'Current password',
    currentPasswordRequired: 'Enter your current password',
    passwordChanged: 'Password changed',
    changePasswordError: 'Could not change the password. Please try again.',
    fields: {
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      phone: 'Phone',
      pk: 'Personal code',
      address: 'Address',
      bankAccount: 'Bank account',
      description: 'About me',
    },
  },
}
